import store from "@/store";
import md5 from "md5";

import { TAlert } from "vue-tailwind/dist/components";

import {
  ComponentName,
  getPluginComponentSetting
} from "@/utils/vue-tailwind.utils";

enum NotificationType {
  Error = "error"
}

interface Notification {
  message: string;
  type: NotificationType;
}

interface IdentifiedNotification extends Notification {
  id: string;
}

const getIdentifiedNotification = ({
  message,
  type
}: Notification): IdentifiedNotification => {
  return {
    id: md5(Date.now().toString()),
    message,
    type
  };
};

const NotificationVTComponentSetting = getPluginComponentSetting({
  componentName: ComponentName.TAlert,
  vueTailwindComponent: TAlert,
  props: {
    fixedClasses: {
      wrapper: "relative flex items-center",
      body: "flex-grow",
      close:
        "absolute relative flex items-center justify-center ml-4 flex-shrink-0 w-8 h-8 transition duration-100 ease-in-out rounded focus:outline-none",
      closeIcon: "fill-current h-6 w-6"
    },
    variants: {
      [NotificationType.Error]: {
        wrapper: "bg-red-600",
        body: "text-white",
        close: "text-white"
      }
    }
  }
});

const addNotification = (notification: Notification): void => {
  store.dispatch("ui/addNotification", notification);
};

export default NotificationVTComponentSetting;
export {
  NotificationType,
  Notification,
  IdentifiedNotification,
  getIdentifiedNotification,
  addNotification
};
